import React from "react";
import AdminNavbar from "components/Navbar/Navbar";
import RequireAuth from "components/RequireAuth";
import Sidebar from "components/Sidebar/Sidebar";
import NotFound from "pages/NotFound/NotFound";
import { Route, Routes } from "react-router-dom";
import userRoles from "utils/roles";
import { toggleContext } from "App";
import { governmentFirmsSidebarRoutes } from "data/sidebar";
import Profile from "pages/Profile/Profile";
import GovernmentAddSurvey from "pages/GovernmentAddSurvey/GovernmentAddSurvey";
import GovernmentListofSurvey from "pages/GovernmentListofSurvey/GovernmentListofSurvey";
import FileManager from "pages/FileManager/FileManager";
import GovernmentDashboard from "pages/GovernmentDashboard/GovernmentDashboard";
import GovernmentStartSurvey from "pages/GovernmentAddSurvey/GovernmentStartSurvey";
import AssessmentAnalysis from "pages/AssessmentAnalysis/AssessmentAnalysis";
import OpportunityList from "pages/OpportunityList/OpportunityList";
import OpportunityDetails from "pages/OpportunityDetails/OpportunityDetails";
import GrowthPlanAssessmentForm from "pages/GrowthPlanAssessmentForm/GrowthPlanAssessmentForm";
import GrowthPlanAssessment from "pages/GrowthPlanAssessment/GrowthPlanAssessment";

const GovFirmsLayout = () => {
  const [isopen, setisOpen] = React.useState(true);
  return (
    <>
      <toggleContext.Provider
        value={{
          isopen,
          setisOpen
        }}
      >
        <Sidebar routes={governmentFirmsSidebarRoutes} />
        <div className={isopen ? "sidecontainer" : "sidecontainerclose"}>
          <AdminNavbar />
          <div className="p-2">
            <Routes>
              <Route element={<RequireAuth allowedRoles={[userRoles.GOVT_FIRMS]} />}>
                <Route path="dashboard" element={<GovernmentDashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="add/Assessment" element={<GovernmentAddSurvey />} />
                <Route path="pending/Assessment/:id" element={<GovernmentAddSurvey />} />
                <Route path="start/Assessment" element={<GovernmentStartSurvey />} />
                <Route path="Assessment/list" element={<GovernmentListofSurvey />} />
                <Route path="assessment/analysis/:id" element={<AssessmentAnalysis />} />
                <Route path="bid/opportunity" element={<OpportunityList />} />
                <Route path="bid/opportunity/:id" element={<OpportunityDetails />} />
                <Route path="file-manager" element={<FileManager />} />
                <Route path="growth-plan-assessment/add" element={<GrowthPlanAssessmentForm />} />
                <Route path="growth-plan-assessment" element={<GrowthPlanAssessment />} />
                <Route
                  path="/unauthorized"
                  element={
                    <NotFound
                      statusCode="403"
                      message="Sorry, you have no privilage to view this page."
                    />
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </div>
        </div>
      </toggleContext.Provider>
    </>
  );
};

export default GovFirmsLayout;
